import { connect } from 'react-redux'
import { getUIScreenshotOverlayVisibility } from '../../selectors/ui'
import ScreenshotOverlay from '../../components/UtilitiesComponents/ScreenshotOverlay'

const mapStateToProps = state => ({
  isVisible: getUIScreenshotOverlayVisibility(state)
})

export default connect(mapStateToProps)(ScreenshotOverlay)
